import { z } from 'zod';
import type { JsonValue } from '~/types';

// Union type for variable values - can be either a string or a parsed JSON object/array
export const zVariableValue = z.union([
  z.string(),
  // Use .passthrough() to allow additional properties that aren't explicitly defined in the schema
  z.object({}).passthrough(), // JSON object
  z.array(z.unknown()), // JSON array
]);

export type VariableValue = z.infer<typeof zVariableValue>;

export const parseVariableValue = (value: string): VariableValue => {
  try {
    const parsed = JSON.parse(value);
    // Only return parsed value if it's an object or array
    if (typeof parsed === 'object' && parsed !== null) {
      return parsed;
    }
    // For primitive JSON values (strings, numbers, booleans), return the original string
    return value;
  } catch {
    // If parsing fails, return the original string
    return value;
  }
};

export const stringifyVariableValue = (value: JsonValue) => {
  if (typeof value === 'string') {
    return value;
  }
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return value?.toString() ?? '';
  }
};
